<script setup lang="ts"></script>

<template>
  <aside
    class="flex w-screen bg-black border-t border-white items-center px-2 sm:px-4 md:px-8 py-2 h-16"
  >
    <div class="ml-auto text-right">
      Department of
      <br />
      Approvals
    </div>
  </aside>
</template>

<style scoped></style>
